import { FaqEntry, FaqSubsection } from './faq.interfaces';

export const data: FaqSubsection[] = [
  {
    title: $localize`Administration and Payment`,
    entries: [
      {
        question: $localize`Can I use UiTPAS?`,
        answer: $localize`At some locations, it is possible to use UiTPAS. You get 1 point per camp. If you have a UiTPAS with a discount rate, choose to pay by bank transfer during registration and mention your UiTPAS number in the UiTPAS/reservation number field. We will adjust the rate and send you a new payment request.`,
        displayedOn: ['faq', 'home'],
      },
      {
        question: $localize`Health Insurance`,
        answer: $localize`Several health insurance funds reimburse part of your registration fee. Three days after the camp, you can find your health insurance certificate on our website after logging in, in your portal under 'My documents'.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Is it safe to pay through this site?`,
        answer: $localize`Absolutely. All payments are made through an encrypted connection. Your data never reaches our computers but goes directly to the bank.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Is it possible to pay in installments?`,
        answer: $localize`No, paying in installments is currently not possible.`,
        displayedOn: ['faq', 'camp'],
      },
      {
        question: $localize`Do I receive a tax certificate?`,
        answer: $localize`In March, you will receive a tax certificate for each camp your children attended the previous year. You can find this certificate from the end of March under your account in the portal (<a href='https://www.skillz.be'>https://www.skillz.be</a>) under 'My documents'. Important! Do not forget to fill in your own national register number and that of your child in the portal.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Can Skillz vzw cancel a camp?`,
        answer: $localize`Yes, if there are too few registrations for a camp, the organization can cancel the camp. However, we will do everything we can to enroll your child in a similar camp at the same location, but unfortunately, we cannot always guarantee this.`,
        displayedOn: ['faq', 'home'],
      },
    ],
  },
  {
    title: $localize`Camps without overnight stay`,
    entries: [
      {
        question: $localize`When are Skillz camps held?`,
        answer: $localize`The camps take place during the school holidays. You will find an overview of upcoming camps on our website. During the autumn and spring holidays there are camps at a limited number of locations in the Antwerp and Mechelen region. We do not organize camps during the Christmas holidays. During the Easter and summer holidays you will find us for one or more weeks at many locations in Flanders.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Are your camps with or without overnight stay?`,
        answer: $localize`We offer both types of camps. You can use the filter on our website to view the options separately.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Who supervises my children at camp?`,
        answer: $localize`Our monitors have a pedagogical and/or didactic background or are currently in training. They are familiar with the location and the camp program they are supervising. We ensure at least one monitor per 12 children. The head monitor, along with the regional manager, oversees the monitors and the general operation of the camp. The management also regularly visits the camps.`,
        displayedOn: ['faq', 'camp'],
      },
      {
        question: $localize`Can I enroll my child for a few days instead of the entire camp?`,
        answer: $localize`Unfortunately, that is not possible. Enrollments are always for the entire duration of the camp.`,
        displayedOn: ['faq', 'camp'],
      },
      {
        question: $localize`Do you have a waiting list?`,
        answer: $localize`Yes. If a camp is fully booked, you can enroll your child on the waiting list at no cost. Follow the normal registration procedure, but if the camp is full, you can reserve instead of paying. As soon as a spot becomes available, we will notify you. You are then free to enroll your child for the camp.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Can I cancel a registration?`,
        answer: $localize`You can cancel up to a week before the start of the camp. Within 4 weeks after the end of the camp, you will receive a refund of the registration fee minus an administrative cost of €30.`,
        displayedOn: ['faq', 'home'],
      },
      {
        question: $localize`Until when can I register?`,
        answer: $localize`For camps without overnight stay, registrations are possible until the day before the camp starts. After that, the online registration module will no longer be available.`,
        displayedOn: ['faq', 'home'],
      },
      {
        question: $localize`Is there childcare provided at the camp?`,
        answer: $localize`Most camps offer childcare from 8 AM and aftercare until 6 PM.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Can children with allergies attend?`,
        answer: $localize`Absolutely. We try to ensure that all children can attend camp! Please clearly indicate this in advance under 'Comments for the camp supervisors' so we can take it into account.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`How can I enroll my child?`,
        answer: $localize`If you are choosing a Skillz camp for the first time, you need to register and enter your personal details. Then you can choose the camp on the holiday camp page and complete the registration via the 'register' button. You can choose to pay immediately online or via bank transfer. If your child has been enrolled with us before, you do not need to register again. You can log in and register for the chosen camp on the 'holiday camps' page.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`What does a camp day look like?`,
        answer: $localize`For camps without overnight stay: Childcare is provided from 8 AM to 6 PM, and activities take place from 9 AM to 4:15 PM. There are 3 hours per day for themed activities and 3 hours for play activities to limit screen time and/or sitting still and to encourage movement. In the morning break, fruit is provided, and in the afternoon break, a cookie is provided, both by Skillz vzw.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`What should I provide for my child?`,
        answer: $localize`You should provide a lunch and a water bottle for your child. The water bottle can be refilled throughout the day. Cookies and fruit for the small breaks are provided by Skillz.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`What happens to lost items?`,
        answer: $localize`Lost items are kept at the camp location throughout the holiday period. The head monitor will be happy to assist you. After that, all items are collected at the headquarters and kept for two months. Any items not claimed after that will be donated to a good cause or given a similar destination.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Is my child insured?`,
        answer: $localize`Our camps include insurance for bodily accidents and civil liability. In case of damage or accident, the Skillz insurance will be called upon after the family insurance and the intervention of your child's health insurance fund. Theft, damage, or loss of material is not insured.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`My child gets sick at camp, is there a refund?`,
        answer: $localize`If your child gets sick at camp and can no longer attend, the unattended days will be refunded, minus an administrative fee of €12. We expect you to provide a doctor's certificate for this.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`What about the Minecraft account and associated settings?`,
        answer: $localize`The full explanation of how to purchase an account with the correct settings can be found here <a href='https://minecraft.skillz.be' target='_blank'>minecraft.skillz.be</a> (FAQ).`,
        displayedOn: ['faq', 'home'],
      },
    ],
  },
  {
    title: $localize`Camps with overnight stay`,
    entries: [
      {
        question: $localize`How do I get to the camp location?`,
        answer: $localize`You come by your own transport. The address can be found in the information email you receive 3 weeks before the start of the camp.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`When does the camp week start and end?`,
        answer: $localize`The start is on Sunday at 3 p.m. and the end is on Friday at 4 p.m. You will also receive an additional information email once you have registered.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Can I help my child settle into their room?`,
        answer: $localize`No, we do this later in the day with the entire group of children. It is best to label the luggage so your child can easily find their own bag.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Can my child sleep in the same room as their friend?`,
        answer: $localize`You can indicate this during the online registration.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Do boys and girls sleep together?`,
        answer: $localize`No, boys and girls sleep in separate rooms. This also applies to brothers and sisters.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`What should I give my child?`,
        answer: $localize`Everything will be listed in the information email you receive 3 weeks in advance. Try to label as much as possible.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`What should I not give my child?`,
        answer: $localize`Expensive cameras, jewelry, video games, MP3 players, iPods, music boxes, etc.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Can my child bring a mobile phone?`,
        answer: $localize`This is at your own responsibility. We want to limit the use, so screen times will be set in consultation with the monitors. This way, your child can stay updated on home matters while enjoying the camp.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Can I visit my child?`,
        answer: $localize`Visits are not allowed. You can send letters or postcards to the accommodation address (see info email).`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Can my child send letters?`,
        answer: $localize`Certainly. However, we do not sell cards or envelopes. Provide these, with name and address, to your child. We will ensure they are mailed.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`What if my child gets sick during the camp?`,
        answer: $localize`We will contact you and discuss whether it is necessary to pick up your child.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Is my child insured?`,
        answer: $localize`Our camps include insurance for bodily accidents and civil liability. In case of damage or accident, the Skillz insurance will be called upon after the family insurance and the intervention of your child's health insurance fund. Theft, damage, or loss of material is not insured.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`My child becomes ill at camp, will I receive a refund?`,
        answer: $localize`If your child becomes ill at camp and can no longer attend, the days not attended will be refunded, minus an administrative cost of €12. We expect you to provide a doctor's certificate for this.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Important documents to bring to the overnight camp?`,
        answer: $localize`Kids ID and medical form. More information about this will follow in the camp's information email.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Who takes care of my child?`,
        answer: $localize`A team of experienced monitors is ready to give your child an unforgettable holiday. A kitchen team provides healthy and delicious meals.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`What about the Minecraft account and associated settings?`,
        answer: $localize`The full explanation of how to purchase an account with the correct settings can be found here <a href='https://minecraft.skillz.be' target='_blank'>minecraft.skillz.be</a> (FAQ).`,
        displayedOn: ['faq'],
      },
    ],
  },
  {
    title: $localize`Workshops`,
    entries: [
      {
        question: $localize`Who do you offer workshops to?`,
        answer: $localize`We focus our workshops on organizations, companies and schools. We do not organize these for private individuals.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Can I book a workshop as a private individual?`,
        answer: $localize`No, our workshops are designed for youth services, libraries, companies, organizations and schools that want to take place at their location/within their event. You are certainly free to contact your local youth service, library or school so that they can organize this in collaboration with us in your region.`,
        displayedOn: ['faq', 'workshop'],
      },
      {
        question: $localize`Which workshops do you offer?`,
        answer: $localize`STEAM* workshops are totally our thing! Consider, for example, Digital Drawing or Virtual Reality. You will find our full range on our website under <a href='https://skillz.be/workshops'>skillz.be/workshops</a>.<br/>(*Science, Technology, Engineering, Arts, Mathematics)`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`How can I book a workshop for my organization?`,
        answer: $localize`Yay, you would like a Skillz workshop! You can book a workshop by contacting us via our contact form on the website or by sending an email to <a href='mailto:workshops@skillz.be'>workshops@skillz.be</a>. Together we will look at the different options and set the date.`,
        displayedOn: ['faq', 'workshop'],
      },
      {
        question: $localize`What is the maximum group size for a workshop?`,
        answer: $localize`We usually work with groups of 12 children. Depending on the question/context this may vary. We also organize walk-in activities.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Can workshops be adapted to our needs?`,
        answer: $localize`Certainly, together we will see what is possible. This way our workshop meets your needs.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Where are the workshops given?`,
        answer: $localize`The workshop takes place at your location. We discuss in advance the requirements that this location must meet in order for the workshop to take place in a pleasant and smooth manner.`,
        displayedOn: ['faq', 'workshop'],
      },
      {
        question: $localize`Do you offer online workshops?`,
        answer: $localize`No, our workshops are all physical workshops. Depending on the demand, it can be a digital or creative theme, but the workshops do not take place online.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`How much does a workshop cost?`,
        answer: $localize`The costs of our workshops depend on the duration, the number of participants and the adaptation to your specific wishes. Contact us for a tailor-made quote. For a workshop of 2-3 hours for 12 children we ask a standard price of €385. We always charge €15 per additional child.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`How long does an average workshop last?`,
        answer: $localize`The duration of a workshop can vary. This ranges from sessions of 2 to 3 hours to a workshop series over several days/moments. Together we can see what is possible in the time frame you have provided.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`How far in advance should I book a workshop?`,
        answer: $localize`We recommend contacting us at least a few weeks in advance. This way you can be sure of a workshop tailored to your needs.`,
        displayedOn: ['faq', 'workshop'],
      },
      {
        question: $localize`What if we have to cancel or move the workshop?`,
        answer: $localize`Canceling or moving a booked workshop is possible. We are happy to discuss the cancellation conditions with you during the booking process. Of course, we would like to be informed as soon as possible of any changes to the planning. Send a message to your contact person or to <a href='mailto:workshops@skillz.be'>workshops@skillz.be</a>.`,
        displayedOn: ['faq', 'workshop'],
      },
    ],
  },
  {
    title: $localize`After school courses - parents`,
    entries: [
      {
        question: $localize`How do I register my child for after-school lessons?`,
        answer: $localize`You can register your child via the online registration form on the school website or via after-school care.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`When do the after-school lessons take place and how long do they last?`,
        answer: $localize`Lessons take place on Monday, Tuesday, Wednesday or Thursday, following school hours. The exact schedule will be announced upon registration.<br/>In total, it is a series of 8 lessons of 1 hour each.`,
        displayedOn: ['faq', 'after-school'],
      },
      {
        question: $localize`Are there costs associated with after-school lessons?`,
        answer: $localize`The price of the series of lessons (8 lessons each of 1 hour) is 72 euros.`,
        displayedOn: ['faq', 'after-school'],
      },
      {
        question: $localize`What happens if my child misses a lesson?`,
        answer: $localize`If your child misses a lesson, they can simply rejoin the next time.`,
        displayedOn: ['faq', 'after-school'],
      },
      {
        question: $localize`How are children picked up after classes?`,
        answer: $localize`After the workshop, children can be picked up at an agreed place. Or they will go back to the childcare centre.`,
        displayedOn: ['faq', 'after-school'],
      },
      {
        question: $localize`What happens if an after-school workshop is cancelled?`,
        answer: $localize`In case of cancellation, we will inform you via e-mail as soon as possible. We will always try to offer a replacement date.`,
        displayedOn: ['faq', 'after-school'],
      },
      {
        question: $localize`Who teaches the after-school workshops?`,
        answer: $localize`Our lessons are taught by experienced teachers with a background subject. They have experience in working with children.`,
        displayedOn: ['faq', 'after-school'],
      },
      {
        question: $localize`What should my child bring to the after-school workshops?`,
        answer: $localize`Nothing, we provide the materials.`,
        displayedOn: ['faq', 'after-school'],
      },
      {
        question: $localize`Where do the lessons take place?`,
        answer: $localize`The lessons take place in a classroom at your child's school or in a daycare room.`,
        displayedOn: ['faq', 'after-school'],
      },
    ],
  },
  {
    title: $localize`After school courses - schools`,
    entries: [
      {
        question: $localize`What are after-school classes?`,
        answer: $localize`After-school classes are educational activities that take place after regular school hours. They offer children the opportunity to gain additional knowledge or skills in a relaxed environment.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`For which age groups are the after-school lessons intended?`,
        answer: $localize`The after-school lessons are intended for children from 3rd to 6th grade. Depending on the topic, certain lessons may be aimed at a more specific age group.`,
        displayedOn: ['faq', 'after-school-schools'],
      },
      {
        question: $localize`What topics are offered within the lesson series?`,
        answer: $localize`STEAM* topics are totally our thing! Consider, for example, Experimenting with science or Robots. You will find our complete range on our website under <a href='https://skillz.be/after-school'>skillz.be/after-school</a>. <br/>(*Science, Technology, Engineering, Arts, Mathematics)`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Where do the lessons take place?`,
        answer: $localize`Workshops take place in a classroom at the school or in a room at the daycare.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`How can I book an after-school series of lessons at our school?`,
        answer: $localize`Yay, you would like a Skillz After-school lesson series! You can book these by contacting us via our contact form on the website or by sending an email to <a href='mailto:info@skillz.be'>info@skillz.be</a>. Together we will look at the different options and set the dates.`,
        displayedOn: ['faq', 'after-school-schools'],
      },
      {
        question: $localize`What is the maximum group size for a series of lessons?`,
        answer: $localize`We usually work with groups of 12 children. Depending on the subject, this may vary slightly.`,
        displayedOn: ['faq', 'after-school-schools'],
      },
      {
        question: $localize`What is the minimum group size for a series of lessons?`,
        answer: $localize`The after-school series of lessons will continue with a minimum of 6 registrations.`,
        displayedOn: ['faq', 'after-school-schools'],
      },
      {
        question: $localize`When do the after-school lessons take place and how long do they last?`,
        answer: $localize`Lessons take place on Monday, Tuesday, Wednesday or Thursday, following school hours. We will look at the exact planning together, also depending on the availability of the teacher.<br/>In total, it is a series of 8 lessons of 1 hour each.`,
        displayedOn: ['faq', 'after-school-schools'],
      },
    ],
  },
  {
    title: $localize`Custom Camps`,
    entries: [
      {
        question: $localize`What are custom camps?`,
        answer: $localize`Customized camps are camps that you take on administratively and organizationally - think: location, registrations, communication with parents - and which we come to implement with our themes, material and monitors. In consultation we will look at which themes and dates are possible to offer the children of your municipality an unforgettable week.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Who are the custom camps for?`,
        answer: $localize`For municipalities or youth services looking for an interesting range of holiday camps within the STEAM* world to offer at their own location. <br/>(*Science, Technology, Engineering, Arts, Mathematics)`,
        displayedOn: ['faq', 'custom-camps'],
      },
      {
        question: $localize`Can you organize a camp at our location without administration for us?`,
        answer: $localize`Yes, that is certainly possible! We understand that administration can be a time-consuming task. That is why we would like to visit you to discuss how we can organize the STEAM* offer at your location, while we take on the administrative tasks. Together we look at the options and ensure a smooth process. Please feel free to contact us for an appointment!<br/>(*Science, Technology, Engineering, Arts, Mathematics)`,
        displayedOn: ['faq', 'custom-camps'],
      },
      {
        question: $localize`What camp themes do you offer?`,
        answer: $localize`STEAM* themes are totally our thing! Consider, for example, Digital Drawing or Robots. You will find our complete range on our website under <a href='https://skillz.be/custom-camps'>skillz.be/custom-camps</a>. <br/>(*Science, Technology, Engineering, Arts, Mathematics)`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`How can I book a tailor-made camp in our municipality?`,
        answer: $localize`Yay, you would like to organize a Skillz camp! You can book these by contacting us via our contact form on the website or by sending an email to <a href='mailto:info@skillz.be'>info@skillz.be</a>. Together we will look at the different options and set the dates.`,
        displayedOn: ['faq', 'custom-camps'],
      },
      {
        question: $localize`Where are the camps held?`,
        answer: $localize`The camp will take place at your location. We discuss in advance the requirements that this place must meet to ensure that a camp can take place in a pleasant and smooth manner.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`How much does a custom camp cost?`,
        answer: $localize`The price of a camp week is determined based on the number of children and whether or not pre- and post-care is offered. We have different formulas for smaller or larger camps. Don't hesitate to contact us for a quote.`,
        displayedOn: ['faq', 'custom-camps'],
      },
      {
        question: $localize`How long does a custom camp last?`,
        answer: $localize`Well, it is tailor-made, so of course you have some say in this. A minimum of 3 camp days is required to have a nice camp structure. A normal camp day with us lasts from 9 a.m. to 4:15 p.m., but we are flexible here too. <br/>If you need activities of less than 3 days, we recommend that you take a look at <a href='https://skillz.be/workshops'>skillz.be/workshops</a>. These activities undoubtedly better suit your question.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`For which age groups are the tailor-made camps intended?`,
        answer: $localize`We offer themes for children between 8 and 16 years old. Depending on the topic, the target group can vary within these ages.<br/>Fact: our teenage camps for target group 12-16 years start a little later in the day. This way they can sleep in a bit before delving into one of our topics.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`We are looking for an offer for teenagers, do you have that?`,
        answer: $localize`Of course! We have an offer for both our younger teenagers (10 - 14) and for the slightly older ones (12 - 16). While we follow the normal daily schedule for the first target group that we also use for younger children, we have a separate teenage camp schedule for 12-16 year olds that is more in line with their rhythm (read: sleep in longer ;)).`,
        displayedOn: ['faq', 'custom-camps'],
      },
    ],
  },
  {
    title: $localize`Integrity`,
    entries: [
      {
        question: $localize`What is integrity?`,
        answer: $localize`Integrity means being honest and sincere in your actions and decisions. In the context of youth activities with holiday camps, this means: that children and young people are treated respectfully, that the law and the rules of the organization are adhered to, that there is transparency about finances and activities, that a safe environment is created and preserve.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Why is integrity important?`,
        answer: $localize`Integrity is important because it ensures a safe and trusting environment for children and young people. This is essential to help them grow and develop.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`What does our organization do to promote integrity?`,
        answer: $localize`Our organization has taken a number of measures to promote integrity. For example, we have appointed an integrity contact point (API). This is a person you can contact if you have any questions or concerns about integrity. There is also a procedure for reporting and investigating integrity issues. This procedure ensures that all reports are handled properly and investigated in a transparent manner. We take measures to prevent conflicts of interest. This means that we ensure that there are no conflicts between the personal interests of our employees and the interests of the organization. Finally, we organize awareness and training about integrity. We believe it is important that all employees know what integrity is and how they can deal with it.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`What can you do as a parent, monitor or child to promote integrity?`,
        answer: $localize`Be alert to your own behavior and that of others. Report any integrity issues you notice. Participate in our organization's awareness and training activities. Comply with the law and the rules of Skillz vzw.`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Where can I find more information about integrity?`,
        answer: $localize`More information can be found on the following websites:<br/>
        <a href='https://www.vlaanderen.be/cjm/nl/jeugd/regelgeving/jeugddecreet' target="_blank">www.vlaanderen.be</a><br/>
        <a href='https://www.facebook.com/vlaamsejeugdraad/?locale=nl_NL' target="_blank">www.facebook.com/vlaamsejeugdraad</a><br/>
        <a href='https://www.jeugdhulp.be/de-integriteit-van-kind-en-jongere-in-de-jeugdsector-info-voor-jongeren' target="_blank">www.jeugdhulp.be<a/>`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Contact details for integrity contact person:`,
        answer: $localize`Name: Hanne Bergers<br/>
        E-mail: <a href='mailto:hanne.bergers@skillz.be'>hanne.bergers@skillz.be</a><br/>
        Phone: <a href='tel:+32471465194'>+32 471 46 51 94</a>`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`How can I make a report?`,
        answer: $localize`You can make a report both anonymously and personalized via our form that you can find at <a href='https://skillz.be/report' target="_blank">https://skillz.be/report</a>`,
        displayedOn: ['faq'],
      },
      {
        question: $localize`Where can I find your integrity policy?`,
        answer: $localize`You can consult the full policy via <a href="https://skillz.be/integrity" target="_blank">https://skillz.be/integrity</a>`,
        displayedOn: ['faq'],
      },
    ],
  },
  {
    title: $localize`How does the monitor portal work?`,
    entries: [
      {
        question: $localize`What should I enter in my profile?`,
        answer: $localize`Check whether all your information is correct. Complete it where required. Are you older than 18? Upload your criminal record - Model 2 <a href="https://airtable.com/appxLQfI3xQ26hnLn/pagUH7OU1yF2cLCA1/form">here</a>. (<a href="https://airtable.com/appxLQfI3xQ26hnLn/pagUH7OU1yF2cLCA1/form">model for minors</a>)`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`Where can I find which information?`,
        answer: $localize`Under your assignments you can find the camps and workshops you've been hired for. You can find userful documents here like an attendants list, manuscripts, games catalogues, location info sheet, ...`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`How do I apply for a camp?`,
        answer: $localize`Under vacancies you can indicate which camps or workshops you'd like to teach. We'll puzzle everything together and update the status. Once you've been assigned, you'll receive an email, and you'll see the assigment appear in your assigments overview.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What else can I do on the portal?`,
        answer: $localize`You can report incidents for insurance purposes, integrity issues, and you can submit expenses you've made for Skillz.`,
        displayedOn: ['monitor'],
      },
    ],
  },
  {
    title: $localize`How does communication happen within Skillz?`,
    entries: [
      {
        question: $localize`How does communication happen during the year?`,
        answer: $localize`We have recently moved to our own Discord server. You'll find several channels here where we make important announcements. Make sure you're part of our server and check it regularly.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`How does communication happen during the camps?`,
        answer: $localize`We have recently moved to our own Discord server. You'll be added to the camp channels a week before the start of the camp. Don't forget to introduce yourself. This channel should be carefully monitored!`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`For which channels do I have to turn on notifications?`,
        answer: $localize`Make sure notifications for the camp channels and theme monitor channels are on. For the other channels you can chose your notification settings as you wish.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What about Slack?`,
        answer: $localize`At the moment our Slack workspace still exists and we are reachable there too. This summer we'll switch to Discord entirely. Slack will ultimately disappear. Don't worry, Discord is quite similar to Slack so you won't have any trouble! The Discord server contains more information on how it works.`,
        displayedOn: ['monitor'],
      },
    ],
  },
  {
    title: $localize`What should I do before I go to camp?`,
    entries: [
      {
        question: $localize`Do I have to follow a briefing?`,
        answer: $localize`<b><u>Yes, the briefing is mandatory!</u></b> We expect all our monitors, regardless of experience, that they follow a briefing at least once a year. You can find the schedule of our briefings on Discord. Briefings answer your questions about start and end hours, your role, the role of the head monitor, the daily structure, expectations and practical matters. Afterward, the presentations are available on Lessonup. Check whether there are theme-specific briefings, for example, for Minecraft. Head monitors and regional managers get extra information during the briefings.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`How do I prepare for my theme?`,
        answer: $localize`<u>Read through the manuscript for your theme(s) carefully before the camp</u>. The manuscripts are available on the portal and in the material boxes. This way you can prepare yourself for all the activities and expectations of a camp. They also tell you whether there is any material you have to bring yourself. For questions about the manuscript or to share ideas and photos, use the Discord theme-specific channel.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`Do I have to check the material?`,
        answer: $localize`<u>YES! Check all material thoroughly on monday morning using the material checklist.</u> Communicate any missing or broken material with the head monitor.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`Is there anything specific I should know about the locations?`,
        answer: $localize`Take a look at the location info sheets beforehand. It contains information about access, wifi, PC, photos, and instructions about rooms, cleanup, and trash. Make sure you know where you're expected on monday morning and which rooms you're allowed to use. Always be friendly when interacting with school personnel.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`Are there any usefull apps to install?`,
        answer: $localize`Yes, there is the Red Cross app. It is useful for first aid instructions and explains step-by-step what to do in various situations. You can also download the 112 app. Make sure that the Discord app is on your phone as well.`,
        displayedOn: ['monitor'],
      },
    ],
  },
  {
    title: $localize`How does the start of a camp week go?`,
    entries: [
      {
        question: $localize`What time should I be present on the first day?`,
        answer: $localize`All monitors must be present by 7:30 AM on Monday morning. You’ll need time to set up your location, check your materials, and make arrangements with the other monitors.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What happens during the welcome of parents and children?`,
        answer: $localize`A warm welcome with a smile is important for a good first impression. Depending on the number of participants, 2 to 4 monitors are needed. Set up a welcome table to check attendance, hand out name stickers, and verify Minecraft logins (or other relevant logins). Engage with the children and provide parents with information about the daily schedule and practical matters. Be approachable and wear a Skillz T-shirt or sweater.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`How do you start the first day?`,
        answer: $localize`Gather all the children at 9:00 AM and introduce all the monitors. Go over a few basic rules, such as phone usage, allowed areas, and cleaning up after breaks. Make sure to play some get-to-know-you games in both small and large groups.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`How are the groups divided?`,
        answer: $localize`Theme groups with more than 10–12 children are split into 2 smaller groups. Grouping is based on requests to be together (as indicated on the participant list) and, where possible, divided by age or experience: younger/less experienced and older/more experienced.`,
        displayedOn: ['monitor'],
      },
    ],
  },
  {
    title: $localize`What is expected of me during the camp week?`,
    entries: [
      {
        question: $localize`What about supervision and breaks?`,
        answer: $localize`The schedule for before- and after-care is decided on the first day (or beforehand) by the head monitor together with the team. We expect you to be present with the children during breaks as well. Every day a piece of fruit and a cookie are provided. Monitors may leave to get lunch if needed, but must return by 12:45. Not everyone can leave at the same time. The entrance must stay closed during breaks for safety. One or two monitors provide before-care from 7:50, after-care lasts until 18:00 at the latest.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`Who is responsible for cleanliness and order?`,
        answer: $localize`Everyone at camp is jointly responsible for keeping the location clean and tidy. Make sure tables are wiped down after meals and breaks, check toilets daily for toilet paper, and empty the bins. Only start activities once the lunchroom is clean. Keep your theme rooms tidy throughout the week — this helps prevent items from being damaged or lost.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What are the guidelines during hot weather?`,
        answer: $localize`Apply sunscreen regularly! During sunny weather, it's important for all skin types to reapply sunscreen frequently during outdoor activities. Children must keep their T-shirt on for extra protection. For water activities, ask children to bring extra dry clothes and a towel. Ensure they drink plenty — schedule enough water breaks!`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`How do I handle medical information and privacy?`,
        answer: $localize`Medical info sheets are available in the camp folder and can also be viewed online. It’s important to know which children need extra care or attention so you can monitor this during the week. Parents or children should never be able to see another child's medical info. Be mindful of privacy: sensitive information must not be shared. Always check which children are not allowed to appear in photos for commercial use.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What should I do in case of accidents or incidents?`,
        answer: $localize`There’s always a first aid kit and a 'First Aid for Youth Leaders' book available. In case of illness or injury, one monitor provides care while the other stays with the group. Communicate clearly in the camp’s Discord channel. Clean up any materials afterward. Medication may only be administered with written parental consent. In case of doubt or serious incidents, immediately notify the responsible person.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What should I do in case of serious injury or fire?`,
        answer: $localize`If someone is seriously injured or there's a fire, call 112. The head monitor takes over and calls the Skillz emergency number. On the first day, agree on an assembly point with the team and explain it to the children. Theme monitors go there with their groups, use the attendance list from the portal to count the children, and report back to the head monitor. The head monitor contacts the Skillz lead (03 375 50 12), fire department (112), and the location's contact person. Stay calm and never go back inside to search for someone.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`How do I deal with the press?`,
        answer: $localize`NEVER speak to the press yourself. Always notify Jelle or Hilde — they handle all media communication.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What is the 'show moment' and what do I need to prepare?`,
        answer: $localize`On the last day, we organize a show moment for all children. This can take many forms: showing crafts or videos, visiting each other’s rooms, or even a full-on performance. Discuss with your fellow monitors what you’ll do. Throughout the week, make sure to take enough photos and videos to share. During the show moment, each child gets a drink and a small gift. Also take a group photo and photos per theme group!`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`How do we clean up the location on the last day?`,
        answer: $localize`On Friday after camp ends, everyone helps tidy up the entire site. All monitors are expected to stay until everything is in order. Sweep and organize all rooms, clean and sort materials according to the inventory list. If no camp is planned for the next week, return everything to “school mode”. The school must be left “broom clean or mopped” as described in the location sheet. It’s VERY IMPORTANT to leave everything spotless to ensure we can rent the location again in the future.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What do we do with the materials on the last day?`,
        answer: $localize`Check and gather all materials thoroughly! Use the color stickers to sort into the correct collection points. Materials to be picked up go to one location, while materials that stay go to another. Make sure each bin is neatly packed, not overflowing, so they can be stacked. Place the material list and activity manual back into the bin. Report any broken or missing items.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`How do we end the week as a team?`,
        answer: $localize`It’s nice to close off the week together in a fun way. How you do that is entirely up to your team — maybe with fries or pizza, for example. You get €3 per monitor (head monitor submits the receipt via the portal).`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What if I get sick?`,
        answer: $localize`Notify your head monitor, your regional coordinator, and your team in the Discord channel as soon as possible. Discuss who can replace you, let them know when you expect to return, and provide a doctor’s note.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`Where can I give feedback?`,
        answer: $localize`At the end of the camp week, you’ll receive a survey to evaluate what went well, what didn’t, and to suggest improvements.`,
        displayedOn: ['monitor'],
      },
    ],
  },
  {
    title: $localize`What should I do as a head monitor or regional coordinator?`,
    entries: [
      {
        question: $localize`Is there a handbook specifically for head monitors?`,
        answer: $localize`Yes, the handbook is available on the portal and explains the basic responsibilities of a head monitor. Make sure to also attend your specific briefing for more details.`,
        displayedOn: ['headMonitor'],
      },
      {
        question: $localize`What are the main responsibilities of the head monitor?`,
        answer: $localize`The head monitor briefs the team on Monday morning, distributes tasks, and gives new monitors a tour. They make the schedule for before- and after-care (on Monday or beforehand), and act as the main point of contact for parents. They ensure the team stays reachable via Discord and relay important updates to the Skillz team or fellow monitors. They brief the team about unexpected events, check delivered materials, and ensure that everything is ready for pickup by Friday evening.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What if there's a trainee?`,
        answer: $localize`You might have an intern doing an animator course on your camp. As head monitor, you supervise this internship. The trainee is always a game monitor. Schedule regular check-ins to discuss expectations, strengths, and areas for improvement. Use their internship booklet to review their competencies. Communicate with the educational lead or co-head monitor about the progress, as the trainee will need to do two weeks and their progress must be passed on.`,
        displayedOn: ['monitor'],
      },
      {
        question: $localize`What are the key responsibilities of a regional coordinator?`,
        answer: $localize`As a regional coordinator, you support several nearby camp locations. You assist when issues arise and offer tips to the team. Sometimes you may need to substitute for an absent monitor. Make sure you have access to a car so you can deliver or buy missing materials as needed.`,
        displayedOn: ['regionalCoordinator'],
      },
      {
        question: $localize`How does communication work?`,
        answer: $localize`Head monitors and regional coordinators have additional private channels on Discord. Keep a close eye on these channels for important updates.`,
        displayedOn: ['monitor'],
      },
    ],
  },
];

export const faqData = () => {
  return data
    .map((section) => {
      return {
        ...section,
        entries: section.entries.filter((entry) =>
          entry.displayedOn.includes('faq'),
        ),
      };
    })
    .filter((section) => section.entries.length);
};

export const homeFaqData: () => FaqEntry[] = () => {
  return data
    .map((section) => {
      return section.entries.filter((entry) =>
        entry.displayedOn.includes('home'),
      );
    })
    .flat();
};

export const afterSchoolWorkshopFaqData: () => FaqEntry[] = () => {
  return data
    .map((section) => {
      return section.entries.filter((entry) =>
        entry.displayedOn.includes('after-school'),
      );
    })
    .flat();
};

export const afterSchoolOrganizationFaqData: () => FaqEntry[] = () => {
  return data
    .map((section) => {
      return section.entries.filter((entry) =>
        entry.displayedOn.includes('after-school-schools'),
      );
    })
    .flat();
};

export const workshopFaqData: () => FaqEntry[] = () => {
  return data
    .map((section) => {
      return section.entries.filter((entry) =>
        entry.displayedOn.includes('workshop'),
      );
    })
    .flat();
};

export const customCampsFaqData: () => FaqEntry[] = () => {
  return data
    .map((section) => {
      return section.entries.filter((entry) =>
        entry.displayedOn.includes('custom-camps'),
      );
    })
    .flat();
};

export const campFaqData: () => FaqEntry[] = () => {
  return data
    .map((section) => {
      return section.entries.filter((entry) =>
        entry.displayedOn.includes('camp'),
      );
    })
    .flat();
};

export const monitorFaqData = () => {
  return data
    .map((section) => {
      return {
        ...section,
        entries: section.entries.filter((entry) =>
          entry.displayedOn.includes('monitor'),
        ),
      };
    })
    .filter((section) => section.entries.length);
};
